import ResourcesAsTransferList from './ResourcesAsTransferList'
export default ResourcesAsTransferList
